import { file_reader } from './file_reader';
import { remote_file_reader } from './remote_file_reader';

import { zip_reader } from './zip';


const file = {	
	file_reader,
	remote_file_reader,
	zip_reader
}

export {
	file
}
